/** @format */

import React, { FunctionComponent } from 'react';
import PliCbd2Interface from '../../../interfaces/platform/PliCbd2Interface';
import { TableRow } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import { AcqOperator } from '../../../interfaces/platform/AcqOperator';

const _ = require('underscore');

export type PliCbd2PortInRowType = {
    pliCbd2: PliCbd2Interface;
    acqOperators: Array<AcqOperator>;
    classes: any;
};

export const PliCbd2PortInRow: FunctionComponent<PliCbd2PortInRowType> = ({ pliCbd2, classes, acqOperators }) => {
    const tableCellRoot = { root: classes.tableCellRoot };

    const getOperatorName = (operatorRpt: string | null): string | null => {
        const acq = _.find(acqOperators, (obj: AcqOperator) => {
            return obj.isMobile && obj.rpt === operatorRpt;
        });
        if (acq) {
            return acq.mainname;
        }
        return null;
    };

    return (
        <TableRow>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {pliCbd2.caseId}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {pliCbd2.msisdn}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="right">
                {pliCbd2.portingDate && DateHelperTs.format(pliCbd2.portingDate)}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {pliCbd2.donor}
                <div style={{ height: '20px' }}>{getOperatorName(pliCbd2.donor)}</div>
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {pliCbd2.recipient}
                <div style={{ height: '20px' }}>{getOperatorName(pliCbd2.recipient)}</div>
            </TableCell>
        </TableRow>
    );
};
